<template>
    <div class="buymodel">
        <div role="main" class="layer_main">
            <div class="row" v-if="page1 ='true'">
                <div class="col-md-12" style="display:flex;flex-direction:row;" >
                    <div class="layer_logo" v-bind:class="data.imgClass" v-bind:style="{backgroundImage:'url(' + data.imgsrc + ')'}"></div>
                    <p class="layer_show" v-html="data.describe">{{data.describe}}</p>
                    <hr>
                </div>
                <div class="col-xs-12 col-xs">
                    <p style="margin-top:0px;font-size: 15px;">请选择支付方式</p>
                </div>
                <div class="col-xs-12 col-xs1">
                    <div class="layer_panel">
                        <div class="">支付平台&nbsp;&nbsp;&nbsp;&nbsp;
                            <img class="layer_payment layer_checked" v-on:click="buy1" payment="alipay" src="../../static/img/logo/pay_1.jpg"> &nbsp;&nbsp;
                            <img class="layer_payment" v-on:click="buy2" payment="wxpay" src="../../static/img/logo/pay_2.jpg">&nbsp;&nbsp;
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 layer_info_div">
                    <p class="layer_p">输入优惠券&nbsp;&nbsp;&nbsp;
                        <input  placeholder="请填写您的优惠券序列号，若无则不填写" name="cdkey" id="quan" style="width:70%" class="quan" autocomplete="off" v-on:blur="checkquan()">
                        <a href="javascript:;" id="cdkeyexplain" style="color: rgb(51, 141, 202);font-size：12px;" v-on:click="explain">使用说明</a>
                    </p>
                </div>
                <div class="col-xs-12">
                    <p class="text-right alert alert-success layer_main_money_panel" style="margin-bottom: 0px;font-weight: bold;">
                        应付金额：<span class="price" v-bind:price='data.price' v-bind:total='data.price' style="font-size: 16px;color: #0088cc;font-weight: bold;">￥{{data.price}}</span>
                    </p>
                </div>
                <label id="label1" class="vl-notify vl-notify-tips vl-notify-tips-1" style="left:590px;top:400px;display:none;background-color:#8a6d3b;font-size:12px;"><p style="color:#fff;font-size:12px;border-radious:5px;width:200px;height:50px;padding:5px 10px;margin-bottom: 0px;">本卷为一次性消费，不得兑换现金，不设找零</p></label>
                <label id="label2" class="vl-notify vl-notify-tips vl-notify-tips-2" style="left:116px;top:436px;display:none;background-color:#ed9c28;font-size:12px;">优惠券无效</label>
                <label id="label3" class="vl-notify vl-notify-tips vl-notify-tips-2" style="left:116px;top:436px;display:none;background-color:#ed9c28;font-size:12px;"></label>
            </div>
            <div class="text-right" style="position:relative;bottom:0;right:0">
                <button type="button" class="btn btn-disabled" v-on:click="buyModelCancel" style="border:0;">返回</button>
                <button type="button"  class="btn btn-primary" style="background-color:#1A8CD8;margin:15px 0px 15px 10px;border:0;" v-on:click="buyModelOk">{{data.title}}</button>
            </div>
        </div>
        <div class="layui-layer layui-layer-page layui--layer-rim" id="layui-layer" type="page" times="23" showtime="0" contype="string" style="z-index: 19891037; width: 360px; height: 360px; top:50%; left: 50%;margin-left:-180px;margin-top:-180px;display:none;">
            <div class="layui-layer-title" id="layui-layer-title">微信扫码支付</div><div id="" class="layui-layer-content ng-scope" style="height: 263px;">
                <div style="text-align: center;">
                    <br>
                    <p style="cursor:defalut;" id="layui-layer-desc">请使用微信扫一扫扫描下方二维码支付</p>
                    <img src="" style="display: inline-block;" id="layui-layer-code">
                </div>
            </div>
            <span class="layui-layer-setwin" v-on:click="buyModelClose">
                <a class="layui-layer-ico layui-layer-close layui-layer-close1" href="javascript:;"></a>
            </span>
            <div class="layui-layer-btn layui-layer-btn-c">
                <a class="layui-layer-btn0" v-on:click="buyModelExamine">完成支付</a><a class="layui-layer-btn1" v-on:click="buyModelClose">使用其他方式支付</a>
            </div>
            <span class="layui-layer-resize"></span>
        </div>
        <div class="layui-layer layui-layer-page" id="layui-layer1" type="page" times="3" showtime="0" contype="string" style="z-index: 19891077;top:50%; left: 50%;width:230px;heigt:160px;margin-left:-115px;margin-top:-80px;display:none;">
            <div class="layui-layer-title" style="cursor: move;">信息</div>
            <div id="layerDemoauto" class="layui-layer-content ng-scope">
                <div style="padding: 20px 70px;font-size:14px;text-align:center;" id="layui-layer-info">购买成功</div>
            </div>
            <span class="layui-layer-setwin" v-on:click="layuiCancel">
                <a class="layui-layer-ico layui-layer-close layui-layer-close1" href="javascript:;"></a>
            </span>
            <div class="layui-layer-btn layui-layer-btn-c" v-on:click="layuiCancel"><a class="layui-layer-btn0">确定</a></div><span class="layui-layer-resize"></span>
        </div>
    </div>
</template>

<script>
    import layer from 'vue-layer';
    var checkcdkey = true;
    var server_head = "http://www.3dmomoda.com:80/";
    // var server_head = "http://47.93.81.139:9115/";
    var orderid = "";
    var checkOrderInterval ="";
    export default {
        name: "buymodel",
        data: function() {
            return {
                loginUser: true,
                imagePath: "http://model.3dmomoda.com/models/",
                imagePath1: "http://static.3dmomoda.com/textures/",
                headImagePath: "https://www.thingjs.com/"
            };
        },
        props: {
            data:{
                type: Object
            },
        },
        methods: {
            buy1: function() {
                $('.layer_payment').removeClass('layer_checked');
                $('.layer_payment').eq(0).addClass('layer_checked');
            },
            buy2: function() {
                $('.layer_payment').removeClass('layer_checked');
                $('.layer_payment').eq(1).addClass('layer_checked');
            },
            explain: function() {
                $('#label1').show();
                setTimeout(function(){
                    $('#label1').hide();
                },1500);
            },
            buyModelOk: function() {
                while (checkcdkey) {
                    var cdkey = $.trim($("input[name=cdkey]").val());
                    if(!/^[a-z0-9]{12,12}$/.test(cdkey)){
                        cdkey = "";
                    }
                    var payment = $(".layer_checked").attr("payment");
                    var total = $(".price").attr("total");
                    var url = server_head+"api/order/submitOrder?userid=13252&r="+new Date().getTime()+"&orderId="+orderid+"&cdkey="+cdkey+"&payment="+payment+"&email=yangna@uinnova.com&_ajax=true";
                    $.ajax({
                        url:server_head+"api/order/submitOrder",
                        type:"post",
                        timeout:"50000",
                        dataType:"text",
                        data:{
                            r:new Date().getTime(),
                            orderId:orderid,
                            cdkey:cdkey,
                            payment:payment,
                            userid:13252,
                            email:"yangna@uinnova.com",
                            _ajax:true
                        },
                        success:function (data) {
                            if(total>0){
                                if(payment=='alipay'){
                                    $('#layui-layer-title').html('支付宝扫码支付');
                                    $('#layui-layer-desc').html('请使用支付宝扫一扫扫描下方二维码支付');
                                    $('#layui-layer-code').attr('src',url);
                                    $('#layui-layer').show();
                                    checkOrderInterval = setInterval(function () {
                                        $.ajax({
                                            url:server_head+"api/order/checkOrder/" + orderid + "-"+payment+"?_ajax=true&userId="+$('#getUserid').val(),
                                            type:"get",
                                            timeout:"50000",
                                            dataType:"json",
                                            data:{},
                                            success:function(data){
                                                if (data.state) {
                                                    if (checkOrderInterval != null) {
                                                        clearInterval(checkOrderInterval);
                                                    }
                                                    $('#layui-layer1').show();
                                                    console.log('支付宝支付成功');
                                                }
                                            }
                                        });
                                    }, 1000);
                                }else {
                                    $('#layui-layer-title').html('微信扫码支付');
                                    $('#layui-layer-desc').html('请使用微信扫一扫扫描下方二维码支付');
                                    $('#layui-layer-code').attr('src',url);
                                    $('#layui-layer').show();
                                    checkOrderInterval = setInterval(function () {
                                        $.ajax({
                                            url:server_head+"api/order/checkOrder/" + orderid + "-"+payment+"?_ajax=true&userId="+$('#getUserid').val(),
                                            type:"get",
                                            timeout:"50000",
                                            dataType:"json",
                                            data:{},
                                            success:function(data){
                                                if (data.state) {
                                                    if (checkOrderInterval != null) {
                                                        clearInterval(checkOrderInterval);
                                                    }
                                                    $('#layui-layer1').show();
                                                    console.log('微信支付成功');
                                                }
                                            }
                                        });
                                    }, 1000);
                                }
                            }else {
                                $.ajax({
                                    url:server_head+"api/order/submitOrder",
                                    type:"post",
                                    timeout:"50000",
                                    dataType:"text",
                                    data:{
                                        r:new Date().getTime(),
                                        orderId:orderid,
                                        cdkey:cdkey,
                                        payment:payment,
                                        _ajax:true
                                    },
                                    success:function (){
                                        $.ajax({
                                            url:server_head+"api/order/checkOrder/" + orderid + "-"+payment+"?_ajax=true&userId="+$('#getUserid').val(),
                                            type:"get",
                                            timeout:"50000",
                                            dataType:"json",
                                            data:{},
                                            success:function(data){
                                                if (data.state) {
                                                    if (checkOrderInterval != null) {
                                                        clearInterval(checkOrderInterval);
                                                    }
                                                    $('#layui-layer1').show();
                                                    console.log('购买完成！');
                                                }
                                            }
                                        });
                                        if (checkOrderInterval != null) {
                                            clearInterval(checkOrderInterval);
                                        }
                                    },
                                    error:function(err){
                                        console.log(err);
                                    }
                                });
                            }
                        },
                        error:function(err){
                            console.log(err)
                        }
                    });
                    break;
                }
            },
            layuiCancel:function(){
                var _this = this;
                var content = $('#layui-layer-info').html();
                if(content=="购买成功"){
                    this.$reqs.get("/model/addBuyCount", {
    					params: {
    						id:this.data.modelId,
    					}
    				}).then(function(result) {
                        $('#layui-layer').hide();
                        $('#layui-layer1').hide();
                        $('.shadowpage').hide();
                        $('.shadowpage1').hide();
                        $('.pc-container3d').hide();
                        _this.$layer.closeAll("iframe");
                        _this.$swal({
                            type: "success",
                            title:'本模型可在CampusBuilder（模模搭）客户端的【右侧模型列表-个人-已购买的模型】和ThingJS在线开发环境的【资源-模型资源-左上菜单-我的】中找到并使用；若客户端中未见此模型，请点击客户端主界面“立即同步”按钮，稍等片刻后，再进入场景重试。',
                            customClass: "sweetAlert7"
                        },function(isConfirm) {
                            if (isConfirm) {}
                        });
                    });
                }else{
                    $('#layui-layer1').hide();
                }
            },
            buyModelClose:function () {
                if(checkOrderInterval!=null){
                  clearInterval(checkOrderInterval);
                }
                $('#layui-layer-title').html('扫码支付');
                $('#layui-layer-desc').html('请使用扫一扫扫描下方二维码支付');
                $('#layui-layer-code').attr('src','');
                $('#layui-layer').hide();
            },
            buyModelExamine:function () {
                var payment = $(".layer_checked").attr("payment");
                $.ajax({
                    url:server_head+'api/order/checkOrder/'+orderid+'-'+payment+'?_ajax=true&userId='+$('#getUserid').val(),
                    type:"get",
                    timeout:"50000",
                    success:function (data) {
                        if(data.state){
                            if(checkOrderInterval!=null){
                              clearInterval(checkOrderInterval);
                            }
                            $('#layui-layer1').show();
                        }else{
                            $('#layui-layer-info').html(data.content);
                            $('#layui-layer1').show();
                        }
                    },
                    error:function(err){
                        console.log(err);
                    }
                });
            },
            buyModelCancel: function() {
                this.$layer.closeAll("iframe");
                if($(".pc-container3d").is(":visible")) {
                    $('.shadowpage1').hide();
                }else {
                    $('.shadowpage').hide();
                }
            },
            checkquan:function(){
                checkcdkey = false;
                var _this = this;
                var val = $('.quan').val();
                var total = $(".price").attr("price");
                if(val!=""){
                    if(val.length==12 && /^[a-z0-9]{12,12}$/.test(val)){
                        $.ajax({
                            url:server_head+"api/order/checkCDKey/"+val,
                            type:"get",
                            timeout:"50000",
                            async:false,
                            success:function (data) {
                                if(data.state){
                                    var discount = data.content.value;
                                    var newtotal = parseFloat(total)-parseFloat(discount);
                                    newtotal = Math.round(newtotal*100)/100;
                                    if(newtotal<0){
                                        newtotal = "0";
                                    }
                                    $(".price").text("￥"+newtotal);
                                    $(".price").attr("total",newtotal);
                                    $("#label3").html('将为您优惠￥'+(discount));
                                    $("#label3").show();
                                    setTimeout(function(){
                                        $('#label3').hide();
                                    },2000);
                                }else{
                                    $(".price").attr("total",total);
                                    $(".price").text("￥"+total);
                                    $('#label2').show();
                                    setTimeout(function(){
                                        $('#label2').hide();
                                    },1000);
                                }
                                checkcdkey = true;
                            },
                            error:function(err){
                                console.log(err);
                            }
                        });
                    }else{
                        $(".price").attr("total",total);
                        $(".price").text("￥"+total);
                        $('#label2').show();
                        setTimeout(function(){
                            $('#label2').hide();
                        },1000);
                        checkcdkey = true;
                    }
                }else{
                    $(".price").attr("total",total);
                    $(".price").text("￥"+total);
                    checkcdkey = true;
                }
            }
        },
        mounted: function() {
            var _this = this;
            $.ajax({
                url:server_head+'api/order/createOrder',
                type:"post",
                timeout:"50000",
                data:{
                    userId : _this.data.id,
                    modelId : _this.data.modelId,
                    sceneId: _this.data.sceneId,
                    type : _this.data.type,
                    email:"yangna@uinnova.com",
                    _ajax:true
                },
                success:function (data) {
                    if(data.state){
                        orderid = data.content.order.orderid;
                    }else {
                        _this.$swal({
                            title: "创建订单失败，请检查网络状态",
                            type: "error",
                            customClass: "sweetAlert3"
                        });
                    }
                },
                error:function(err){
                    console.log(err);
                }
            });
        }
    };
</script>

<style>
    input{
    	border: 1px solid #cfcfcf;
    	font-size: 13px;
    }
    .btn {
    	display: inline-block;
    	padding: 6px 12px;
    	margin-bottom: 0;
    	font-size: 14px;
    	font-weight: 400;
    	line-height: 1.42857143;
    	text-align: center;
    	white-space: nowrap;
    	vertical-align: middle;
    	-ms-touch-action: manipulation;
    	touch-action: manipulation;
    	cursor: pointer;
    	-webkit-user-select: none;
    	-moz-user-select: none;
    	-ms-user-select: none;
    	user-select: none;
    	background-image: none;
    	border: 1px solid transparent;
    	border-radius: 4px;
    	margin: 0px;
    }
    .btn-primary {
    	color: #fff;
    	background-color: #337ab7;
    	border-color: #2e6da4;
    }
    .btn-primary:visited {
    	color: #fff;
    	background-color: #337ab7;
    	border-color: #2e6da4;
    }
    .btn:focus {
    	color: #fff;
    }
    .vl-notify .vl-notify-content {
    	min-height: 65px;
    	padding: 0px;
    }
    .vl-notify.vl-notify-main {
    	min-width: 250px;
    	max-width: 1500px;
    	min-height: 100px;
    	background-color: #fff;
    	border: none;
    	border-radius: 5px;
    	padding-bottom: 5px;
        color: #333;
        animation: none;
    }
    .vl-notify.vl-notify-alert h2.vl-notice-title {
    	box-sizing: border-box;
    	width: 100%;
    	height: 57px !important;
    	line-height: 27px !important;
    	border:0px !important;
    	padding-left: 25px !important;
    	cursor: default !important;
    	-moz-user-select: -moz-none;
    	-webkit-user-select: none;
    	margin: 0 !important;
    	background-color:white !important;
    	color: #333333 !important;
    	font-family: "微软雅黑" !important;
    	font-size: 18px !important;
    	font-weight: 400 !important;
    	padding-top: 20px !important;
    	border-top-left-radius: 5px !important;
    }
    .layer_payment{
    	display: inline;
    	max-width: 100%;
    	height: auto;
    	border: 1px solid #ccc;
    	cursor: pointer;
    }
    .text-right {
    	text-align: right;
    	height: 53px;
    }
    .layer_main {
    	width:100%;
    	height: 100%;
    	overflow: hidden;
    }
    .layer_main_money_panel {
    	background-color: #efefef;
    	border-color: #efefef;
    	color: #595a59;
    	font-size: 16px;
    	font-weight: bold;
    }
    .alert-success {
    	background-color: #efefef;
    	border-color: #efefef;
    	color: #595a59;
    }
    .alert {
    	padding: 15px;
    	margin: 0;
    	margin-bottom: 20px;
    	border-radius: 4px;
    }
    .layer_p {
    	margin-bottom: 15px;
    	font-size: 15px;
    }
    .buymodel {
        width: 100%;
        padding: 0px 25px;
        box-sizing: border-box;
    }
    .layer_info_div {
    	width: 100%;
    	padding: 15px 15px 0px 15px;
    }
    .layer_checked {
    	border: 1px solid #0088cc;
    }
    .layer_panel {
    	width: 100%;
    	height: 79px;
    	margin: 15px 0;
    	border: 1px solid #d2d2d2;
    	border-radius: 2px;
    	padding: 15px;
    }
    .layer_show span {
    	display: inline-block;
    	width: 190px;
    	font-size: 12px;
    }
    .col-xs {
    	height: 20px;
    }
    .col-xs1 {
    	height: 96px;
    }
    .col-xs-12 .col-md-12 {
    	width: 100%;
    	float: left;
    	position: relative;
    	min-height: 1px;
    	padding-right: 15px;
    	padding-left: 15px;
    }
    .layer_show {
    	display: inline-block;
    	width: 210px;
    	line-height: 24px;
    	margin: 0px 0px 20px;
    	cursor: default;
    	color: #333;
    	font-size: 13px;
        word-wrap: break-word;
        word-break: break-all;
    }
    .modelid1 {
    	display: block;
    	transform: scale(0.6, 0.6);
    }
    .layer_logo{
    	width: 360px;
    	height: 202px;
    	margin-right: 18px;
        margin-bottom: 15px;        
        background-repeat: no-repeat;
        background-position: center center;
    }
    .layer_logo_1{
        background-size: 60%;
    }
    .layer_logo_2{
        background-size: 100%;
    }
    .vl-notify.vl-notify-alert h2.vl-notice-title .icon-remove{
    	position: absolute;
    	right: -15px;
    	top: -15px;
    	width: 30px;
    	height: 30px;
    	margin-left: 0;
    	background: url(../../static/img/icon.png) no-repeat !important;
    	background-position: -149px -31px !important;
    	font-size: 0px !important;
    }
    .vl-notify.vl-notify-tips-1:after{
    	border-bottom-color: #8a6d3b !important;
    }
    .vl-notify.vl-notify-tips-2:after{
    	border-right-color: #ed9c28 !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/PurchaseModel.vue